/* eslint-disable */
export default {
  All: 'all',
  OnlyErrors: 'errors',
  OnlySuccessful: 'success'
};

